import React, { useEffect, useState } from "react";
import axios from 'axios';
import Onrc_Alloted_Sub_Dist_fps from "./Onrc_Alloted_Sub_Dist_fps";

const Onrc_Alloted_Int_Afso = ({ heading, sub = "" }) => {

  const [districtView, setDistrictView] = useState(null);
  const [depotView, setDepotView] = useState(null);
  const [fpsView, setFpsView] = useState(null);

  const [cmonth, setMonth] = useState(new Date().getMonth() + 1);
  const [cyear, setYear] = useState(new Date().getFullYear());

  const [comm, setComm] = useState({ id: "0", name: "ALL Commodities" });
  const [scheme, setScheme] = useState({ id: "0", name: "ALL Scheme" });

  const [dist, setDist] = useState({ id: "all", name: "ALL" });
  const [mandal, setMandal] = useState({ id: "all", name: "ALL" });

  const [districtDrop, setDistrictDrop] = useState([]);
  const [mandalDrop, setMandalDrop] = useState([]);

  const [commoditiesList, setCommoditiesList] = useState([]);
  const [schemeList, setSchemeList] = useState([]);

  const [reportType, setReportType] = useState("IMPDS");

  const Months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const Years = [
    new Date().getFullYear() - 1,
    new Date().getFullYear(),
    new Date().getFullYear() + 1
  ];

  useEffect(() => {

    setDist({ id: "all", name: "ALL" });
    setMandal({ id: "all", name: "ALL" });
    setMandalDrop([]);
    setComm({ id: "0", name: "ALL Commodities" });
    setScheme({ id: "0", name: "ALL Scheme" });

    setDistrictView(null);
    setDepotView(null);
    setFpsView(null);

    axios.get(`${process.env.REACT_APP_URL}/api/onrcReports/get-all-district`)
      .then(res => {
        const data = res.data;
        setDistrictDrop(Array.isArray(data) ? data : []);
      })
      .catch(console.error);

  }, [heading, sub]);


  useEffect(() => {
    setMandal({ id: "all", name: "ALL" });
    setMandalDrop([]);

    if (dist.id !== "all") {
      axios.get(`${process.env.REACT_APP_URL}/api/onrcReports/get-dist-mandal/${dist.id}`)
        .then(res => {
          const data = res.data;
          setMandalDrop(Array.isArray(data) ? data : []);
        })
        .catch(console.error);
    }
  }, [dist.id]);


  useEffect(() => {
    setCommoditiesList([]);
    setSchemeList([]);

    axios.get(`${process.env.REACT_APP_URL}/api/onrcReports/get-onrc-commodity/${cmonth}/${cyear}`)
      .then(res => {
        const data = res.data;
        const responseData = Array.isArray(data) ? data : [];

        const commodityMap = new Map();
        const schemeMap = new Map();

        responseData.forEach(item => {

          if (item.id && !commodityMap.has(item.id)) {
            commodityMap.set(item.id, {
              id: item.id,
              name: item.name
            });
          }


          if (item.scheme_id && !schemeMap.has(item.scheme_id)) {
            schemeMap.set(item.scheme_id, {
              id: item.scheme_id,
              name: item.scheme_name_en
            });
          }
        });

        setCommoditiesList([...commodityMap.values()]);
        setSchemeList([...schemeMap.values()]);
      })
      .catch(console.error);

  }, [cmonth, cyear]);


  const handleSubmit = () => {

    setDepotView(null);
    setFpsView(null);

    setDistrictView(
      <Onrc_Alloted_Sub_Dist_fps
        month={cmonth}
        year={cyear}
        comm_id={comm.id === "0" ? null : comm.id}
        commname={comm.name}
        dist_code={dist.id === "all" ? null : dist.id}
        afso_code={mandal.id === "all" ? null : mandal.id}
        heading={heading}
        dist={dist.name}
        mandal={mandal.name}
        scheme={scheme.id === "0" ? null : scheme.id}
        reportType={reportType}
        setDepotView={setDepotView}
        setFpsView={setFpsView}
      />
    );
  };

  return (
    <div className="wrapper row3">
      <div id="container">

        <table width="100%">
          <thead>
            <tr className="tableheader">
              <th colSpan={14}>{heading}</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td align="center"><b>Month:</b></td>
              <td>
                <select value={cmonth} onChange={e => setMonth(+e.target.value)}>
                  {Months.map((m, i) => (
                    <option key={i} value={i + 1}>{m}</option>
                  ))}
                </select>
              </td>

              <td align="center"><b>Year:</b></td>
              <td>
                <select value={cyear} onChange={e => setYear(+e.target.value)}>
                  {Years.map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </td>

              <td><b>Commodity:</b></td>
              <td>
                <select
                  value={comm.id}
                  onChange={e => {
                    const opt = e.target.options[e.target.selectedIndex];
                    setComm({ id: e.target.value, name: opt.text });
                  }}
                >
                  <option value="0">ALL Commodities</option>
                  {commoditiesList.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>

              <td><b>Scheme:</b></td>
              <td>
                <select
                  value={scheme.id}
                  onChange={e => {
                    const opt = e.target.options[e.target.selectedIndex];
                    setScheme({ id: e.target.value, name: opt.text });
                  }}
                >
                  <option value="0">ALL Scheme</option>
                  {schemeList.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>

              <td><b>District:</b></td>
              <td>
                <select
                  value={dist.id}
                  onChange={e => {
                    const opt = e.target.options[e.target.selectedIndex];
                    setDist({ id: e.target.value, name: opt.text });
                  }}
                >
                  <option value="all">ALL District</option>
                  {districtDrop.map((item, i) => (
                    <option key={i} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>

              <td><b>Mandal:</b></td>
              <td>
                <select
                  value={mandal.id}
                  onChange={e => {
                    const opt = e.target.options[e.target.selectedIndex];
                    setMandal({ id: e.target.value, name: opt.text });
                  }}
                >
                  <option value="all">All Mandal</option>
                  {mandalDrop.map((item, i) => (
                    <option key={i} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>

              <td><b>Type:</b></td>
              <td>
                <select value={reportType} onChange={e => setReportType(e.target.value)}>
                  <option value="IMPDS">IMPDS</option>
                  <option value="REG">REG</option>
                </select>
              </td>
            </tr>

            <tr>
              <td colSpan={14} align="center">
                <button onClick={handleSubmit} className="button button2">
                  Submit
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <br />

        <div id="detailsER">
          {districtView}
          {depotView}
          {fpsView}
        </div>

      </div>
    </div>
  );
};

export default Onrc_Alloted_Int_Afso;


